import { Box, styled, Typography } from '@mui/material';

export const Container = styled(Box)`
  padding: 30px 30px 42px 30px;
  background: ${({ theme }) => theme.palette.grey[50]};
  width: 100%;
  height: 100%;
  overflow-y: overlay;
`;

export const Page = styled(Box)`
  height: 60vh;
`;

export const SectionUser = styled(Box)`
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
`;

export const Div = styled(Box)`
  .name-user {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .active {
    padding: 4px 12px;
    text-align: center;
    width: 57px;
    height: 28px;
    background: #4caf50;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #ffffff;
  }

  .pendent {
    padding: 4px 12px;
    width: 85px;
    height: 28px;
    background: #ffb547;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #ffffff;
  }

  .desactive {
    padding: 4px 12px;
    height: 28px;
    background: #d62237;
    border-radius: 50px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #ffffff;
    text-align: center;
  }

  .text-details {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #323232;
  }

  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const TextDialog = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: #4caf50;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  margin-bottom: 30px;
`;
